import React from 'react'
import '../Pages/Firstpage.css';
import Software from '../Images/Logos/Software_logo.svg'
import Fullstack from '../Images/Logos/Fullstact_logo.svg'
import Mobile from '../Images/Logos/Mobile_logo.svg'
import ARVR from '../Images/Logos/ARVR.jpg'
import Banking from '../Images/Logos/Banking.jpg'
import Health from '../Images/Logos/Health.jpg'
import IOT from '../Images/Logos/IOT.jpg'
import portfolio_image from '../Images/portfolio_image.png';
import project_worker_image from '../Images/project_worker_image.jpg';


export default function Firstpage() {
  return (
    <>
      {/* --------------BANNER SECTION STARTS-------------- */}

      <section class="banner">
        <div class="container">
          <div class="row">
            <div class="banner_text_box">
              <div class="banne_main_box">
                <h1 class="banner_text">
                  Your Web Development Partner for Innovative and Impactful Digital Solutions
                </h1>
                <div class="banner_buttons">
                  <div class="banner_first_button">
                    <button>VIEW CASE STUDIES</button>
                  </div>
                  <div class="banner_second_button">
                    <button>CONTACT US</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------BANNER SECTION ENDS-------------- */}

      {/* -------------COMPANY DETAIL SECTION STARTS----------- */}

      <section class="company_section">
        <div class="container">
          <div class="row">
            <div class="col-md-3">
              <div class="company_detail">
                <h3>12+</h3>
                <h6>Year in the Business</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div class="company_detail">
                <h3>750+</h3>
                <h6>Solutions Delivered</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div class="company_detail">
                <h3>200+</h3>
                <h6>Technology Experts</h6>
              </div>
            </div>

            <div class="col-md-3">
              <div class="company_detail">
                <h3>$50M+</h3>
                <h6>Business Delivered</h6>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* -------------COMPANY DETAIL SECTION ENDS----------- */}

      {/* -----------------INNOVATION SECTION STARTS------------------- */}

      <section class="innovation_section">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="innovation_text_area">
                <div class="innovation_text_main_heading">
                  <h3>Top Rated Web Development Company Fueling Innovation</h3>
                </div>
                <div class="innovation_text_heading_text">
                  <h5>We proactively consult, design , develop & scale robust web, mobile & custom software solutions, that
                    fuel innovation & deliver digital success!</h5>
                </div>
                <div class="innovation_text_paragraph">
                  <p>
                    At Unified we believe that every project is an important milestone in our journey.
                    Hence, we position ourselves as a custom
                    web development company specializing in developing impactful digital
                    solutions with industry best practices across the board, for Fortune 500's, SMEs, and Start-up’s around
                    the globe.
                  </p>
                </div>
                <div class="innovation_button">
                  <button>REQUEST CONSULTATION</button>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="innovation_image_section">
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* -----------------INNOVATION SECTION ENDS------------------- */}

      {/* --------------------CORE SERVICES SECTION STARTS------------------ --> */}

      <div class="coreservices_main_section">
        <div class="coreservices_section">
          <div class="core_section">
            <h3>Core</h3>
          </div>
          <div class="services_section">
            <h3>services</h3>
          </div>
        </div>
      </div>

      {/* --------------------CORE SERVICES SECTION ENDS------------------ */}

      {/* -------------------DEVELOPMENT CARD SECTION STARTS-------------------- */}

      <section class="development_card_section">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="development_card">
                <div class="development_card_image">
                  <img src={Software} alt="Custom Software Development Logo" />
                </div>
                <div class="development_card_heading">
                  <h2>
                    Custom Software Development
                  </h2>
                </div>
                <div class="development_card_text">
                  <p>
                    From highly robust SaaS platforms to business portals,
                    eCommerce solutions, content management systems,
                    our team of expert web developers coupled with
                    industry best project governance ensures top level
                    web development solutions across industries for businesses around the globe.
                  </p>
                </div>
                <div class="development_card_page_link">
                  <span>READ MORE </span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="development_card">
                <div class="development_card_image">
                  <img src={Fullstack} alt="Full Stack Website Development Logo" />
                </div>
                <div class="development_card_heading">
                  <h2>Full Stack Website Development</h2>
                </div>
                <div class="development_card_text">
                  <p>
                    From highly robust SaaS platforms to business portals,
                    eCommerce solutions, content management systems,
                    our team of expert web developers coupled with
                    industry best project governance ensures top level
                    web development solutions across industries for businesses around the globe.
                  </p>
                </div>
                <div class="development_card_page_link">
                  <span>READ MORE </span>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="development_card">
                <div class="development_card_image">
                  <img src={Mobile} alt="Mobile Application Development Logo" />
                </div>
                <div class="development_card_heading">
                  <h2>Mobile Application Development</h2>
                </div>
                <div class="development_card_text">
                  <p>
                    From highly robust SaaS platforms to business portals,
                    eCommerce solutions, content management systems,
                    our team of expert web developers coupled with
                    industry best project governance ensures top level
                    web development solutions across industries for businesses around the globe.
                  </p>
                </div>
                <div class="development_card_page_link">
                  <span>READ MORE</span>
                </div>
              </div>
            </div>
            <div class="development_card_button_adjust">
              <button>
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      </section>


      {/* -------------------DEVELOPMENT CARD SECTION ENDS-------------------- --> */}

      {/* --------------------SECOND CORE SERVICES SECTION STARTS------------------ --> */}

      <div class="coreservices_main_section">
        <div class="coreservices_section">
          <div class="core_section">
            <h3>Portfolio that</h3>
          </div>
          <div class="services_section">
            <h3>speak!</h3>
          </div>
        </div>
      </div>

      {/* --------------------SECOND CORE SERVICES SECTION ENDS------------------ */}

      {/* --------------------OUR EXPERTISE SECTION STARTS------------------ */}

      <section class="our_expertise">
        <div class="container">
          <div class="our_expertise_heading">
            <h2>Our expertise</h2>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="our_expertise_card">
                <div class="our_expertise_card_image">
                  <img src={ARVR} alt="AR/VR Image"/>
                </div>
                <div class="our_expertise_card_text_area">
                  <div class="our_expertise_card_text_area_heading">
                    <h3>AR/VR</h3>
                  </div>
                  <div class="our_expertise_card_text_area_paragraph">
                    <p>
                      We design & develop user-engaging eCommerce applications
                      that improve ROI, increase brand exposure, and skyrocket your online business.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="our_expertise_card">
                <div class="our_expertise_card_image">
                  <img src={Banking} alt="Banking & Finance Image" />
                </div>
                <div class="our_expertise_card_text_area">
                  <div class="our_expertise_card_text_area_heading">
                    <h3>Banking & Finance</h3>
                  </div>
                  <div class="our_expertise_card_text_area_paragraph">
                    <p>
                      Our smart & customer-centric solutions assist businesses to outsmart competitors and modernize
                      banking and finance-related services.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="our_expertise_card">
                <div class="our_expertise_card_image">
                  <img src={IOT} alt="Blockchain & IOT Image" />
                </div>
                <div class="our_expertise_card_text_area">
                  <div class="our_expertise_card_text_area_heading">
                    <h3>Blockchain & IOT</h3>
                  </div>
                  <div class="our_expertise_card_text_area_paragraph">
                    <p>
                      Let your customers experience the future and transform your business with our
                      high-end Blockchain & IoT solutions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="our_expertise_card">
                <div class="our_expertise_card_image">
                  <img src={Health} alt="Health & Fitness IMAGE" />
                </div>
                <div class="our_expertise_card_text_area">
                  <div class="our_expertise_card_text_area_heading">
                    <h3>Health & Fitness</h3>
                  </div>
                  <div class="our_expertise_card_text_area_paragraph">
                    <p>
                      Get high-end mhealth solutions to improve medical care & patient services.
                      Our tech solutions are redefining healthcare service.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------OUR EXPERTISE SECTION ENDS------------------ */}

      {/* --------------------PORTFOLIO SECTION STARTS------------------ */}

      <section className='portfolio_section'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='portfolio_image'>
                <img src={portfolio_image} />
              </div>
            </div>
            <div className='col-md-6'>
              <div className='main_portfolio_text'>
                <div className='portfolio_text'>
                  <div className='portfolio_text_image'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="146" height="32" viewBox="0 0 146 32">
                      <g fill="none" fill-rule="evenodd">
                        <path fill="#000" d="M2.32 6.36c0 1.408.4 2.507 1.2 3.296.8.79 1.765 1.184 2.896 1.184 1.13 0 2.096-.395 2.896-1.184.8-.79 1.2-1.888 1.2-3.296s-.4-2.504-1.2-3.288c-.8-.784-1.765-1.176-2.896-1.176-1.13 0-2.096.392-2.896 1.176-.8.784-1.2 1.88-1.2 3.288zm-1.6 0c0-.917.163-1.755.488-2.512.325-.757.757-1.379 1.296-1.864A5.996 5.996 0 0 1 4.32.856c.672-.267 1.37-.4 2.096-.4.725 0 1.424.133 2.096.4a5.996 5.996 0 0 1 1.816 1.128c.539.485.97 1.107 1.296 1.864.325.757.488 1.595.488 2.512 0 1.216-.28 2.283-.84 3.2-.56.917-1.267 1.6-2.12 2.048a5.8 5.8 0 0 1-2.736.672 5.8 5.8 0 0 1-2.736-.672c-.853-.448-1.56-1.13-2.12-2.048C1 8.643.72 7.576.72 6.36zm18.88 8.72h-1.488V4.344h1.456v1.2c.224-.405.56-.736 1.008-.992.448-.256.97-.384 1.568-.384 1.11 0 1.976.379 2.6 1.136.624.757.936 1.717.936 2.88 0 1.173-.323 2.144-.968 2.912-.645.768-1.517 1.152-2.616 1.152-.565 0-1.067-.117-1.504-.352-.437-.235-.768-.533-.992-.896v4.08zm4.544-6.896c0-.779-.205-1.421-.616-1.928-.41-.507-.963-.76-1.656-.76-.683 0-1.235.253-1.656.76-.421.507-.632 1.15-.632 1.928 0 .8.21 1.453.632 1.96.421.507.973.76 1.656.76.683 0 1.232-.253 1.648-.76.416-.507.624-1.16.624-1.96zm8.432-.784h4.208c-.021-.576-.213-1.048-.576-1.416-.363-.368-.875-.552-1.536-.552-.597 0-1.088.195-1.472.584-.384.39-.592.85-.624 1.384zm4.432 2l1.296.448a3.408 3.408 0 0 1-1.248 1.752c-.608.453-1.344.68-2.208.68-1.077 0-1.992-.37-2.744-1.112-.752-.741-1.128-1.741-1.128-3 0-1.173.363-2.144 1.088-2.912.725-.768 1.59-1.152 2.592-1.152 1.163 0 2.07.365 2.72 1.096.65.73.976 1.71.976 2.936 0 .192-.01.352-.032.48h-5.792c.01.683.237 1.243.68 1.68.443.437.99.656 1.64.656 1.099 0 1.819-.517 2.16-1.552zm8.768-1.808v4.448h-1.504V4.344h1.472v1.104c.512-.885 1.301-1.328 2.368-1.328.885 0 1.565.283 2.04.848.475.565.712 1.296.712 2.192v4.88H49.36V7.416c0-1.29-.597-1.936-1.792-1.936-.565 0-1.005.2-1.32.6-.315.4-.472.904-.472 1.512zm15.76-3.328v1.6a4.636 4.636 0 0 0-.656-.048c-1.408 0-2.112.79-2.112 2.368v3.856h-1.504V4.344h1.472v1.344c.47-.981 1.237-1.472 2.304-1.472.17 0 .336.016.496.048zM68.032 7.4h4.208c-.021-.576-.213-1.048-.576-1.416-.363-.368-.875-.552-1.536-.552-.597 0-1.088.195-1.472.584-.384.39-.592.85-.624 1.384zm4.432 2l1.296.448a3.408 3.408 0 0 1-1.248 1.752c-.608.453-1.344.68-2.208.68-1.077 0-1.992-.37-2.744-1.112-.752-.741-1.128-1.741-1.128-3 0-1.173.363-2.144 1.088-2.912.725-.768 1.59-1.152 2.592-1.152 1.163 0 2.07.365 2.72 1.096.65.73.976 1.71.976 2.936 0 .192-.01.352-.032.48h-5.792c.01.683.237 1.243.68 1.68.443.437.99.656 1.64.656 1.099 0 1.819-.517 2.16-1.552zm8.24-2h4.208c-.021-.576-.213-1.048-.576-1.416-.363-.368-.875-.552-1.536-.552-.597 0-1.088.195-1.472.584-.384.39-.592.85-.624 1.384zm4.432 2l1.296.448a3.408 3.408 0 0 1-1.248 1.752c-.608.453-1.344.68-2.208.68-1.077 0-1.992-.37-2.744-1.112-.752-.741-1.128-1.741-1.128-3 0-1.173.363-2.144 1.088-2.912.725-.768 1.59-1.152 2.592-1.152 1.163 0 2.07.365 2.72 1.096.65.73.976 1.71.976 2.936 0 .192-.01.352-.032.48h-5.792c.01.683.237 1.243.68 1.68.443.437.99.656 1.64.656 1.099 0 1.819-.517 2.16-1.552zm8.768 2.64H92.4V.456h1.504V12.04zm16.32 0h-1.6V.696h1.6V12.04zm8.224-4.448v4.448h-1.504V4.344h1.472v1.104c.512-.885 1.301-1.328 2.368-1.328.885 0 1.565.283 2.04.848.475.565.712 1.296.712 2.192v4.88h-1.504V7.416c0-1.29-.597-1.936-1.792-1.936-.565 0-1.005.2-1.32.6-.315.4-.472.904-.472 1.512zm14.72-2.096c-.65 0-1.203.235-1.656.704-.453.47-.68 1.13-.68 1.984 0 .843.227 1.504.68 1.984.453.48 1.01.72 1.672.72.64 0 1.128-.16 1.464-.48.336-.32.563-.688.68-1.104l1.328.576c-.213.64-.616 1.2-1.208 1.68s-1.347.72-2.264.72c-1.12 0-2.048-.39-2.784-1.168-.736-.779-1.104-1.755-1.104-2.928 0-1.195.368-2.173 1.104-2.936.736-.763 1.659-1.144 2.768-1.144.939 0 1.699.24 2.28.72.581.48.963 1.056 1.144 1.728l-1.36.576a2.43 2.43 0 0 0-.672-1.152c-.33-.32-.795-.48-1.392-.48zm9.088 5.52c0-.31.107-.573.32-.792.213-.219.475-.328.784-.328.31 0 .573.11.792.328.219.219.328.483.328.792 0 .31-.11.57-.328.784-.219.213-.483.32-.792.32-.31 0-.57-.107-.784-.32a1.066 1.066 0 0 1-.32-.784z" />
                        <path stroke="#00ACFF" stroke-linecap="square" stroke-width="2" d="M1.5 30.5h47" />
                      </g>
                    </svg>
                  </div>
                  <div className='portfolio_text_heading'>
                    <h3>A patented multi-million SaaS video platform</h3>
                  </div>
                  <div className='portfolio_text_paragraph'>
                    <p>
                      We created a patented video platform that helps capture and direct video remotely.
                      This has helped companies reduce production cost,
                      resource and time. Now shoot video without even stepping out of your comfort zone.
                    </p>
                  </div>
                  <div className='portfolio_buttons'>
                    <div class="banner_buttons">
                      <div class="banner_first_button">
                        <button>VIEW PORTFOLIO</button>
                      </div>
                      <div class="banner_second_button">
                        <button>CONTACT US</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------PORTFOLIO SECTION ENDS------------------ */}

      {/* --------------------PROJECT SECTION STARTS------------------ */}

      <section className='project_section'>
        <div className='container-fluid pt0'>
          <div className='row'>
            <div className='col-md-6'>
              <div className='project_worker'>
                <div className='project_worker_details'>
                  <div className='project_worker_details_image'>
                    <img src={project_worker_image} />
                  </div>
                  <div className='project_worker_details_logo'>
                    <img src="https://www.unifiedinfotech.net/assets/images/Mobile-App-Linkedin-Icon.svg" alt="LinkedIn_Logo" />
                  </div>
                  <div className='project_worker_details_message'>
                    <blockquote>
                      <span class="start-quote"></span>
                      The team's in-depth knowledge of user interaction and behavior resulted in an impressive UI/UX design.
                    </blockquote>
                  </div>
                  <div className='project_worker_details_profile'>
                    <div className='project_worker_details_profile_name'>
                      <p><strong>Leonardo Rodriguez</strong></p>
                    </div>
                    <div className='project_worker_details_profile_designation'>
                      <p>Technical PM, Reliable Group</p>
                    </div>
                  </div>
                  <div className='project_worker_details_end'>
                    <div className='project_worker_details_end_circle'></div>
                    <div className='project_worker_details_end_circle'></div>
                    <div className='project_worker_details_end_circle'></div>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-6'>
              <div className='project_form'>
                <div className='project_form_input'>
                  <div className='project_form_input_text'>
                    <h2><strong>Have a project to discuss?</strong></h2>
                    <h2><strong>Get in touch.</strong></h2>
                  </div>
                  <form action='#' method='GET'>
                    <div className='name_field'>
                      <input type="text" placeholder="Name" />
                    </div>
                    <div className='contact_field'>
                      <input type="text" placeholder="Email" />
                      <input type="text" placeholder='Phone' />
                    </div>
                    <div className='message_field'>
                      <input type="textarea" placeholder='Message' />
                      <div className='form_message'>
                        <span>
                          Note : We'll keep your idea confidential with a signal NDA.
                        </span>
                      </div>
                    </div>
                    <div className='form_submit_button'>
                      <button>SUBMIT</button>
                      </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* --------------------PROJECT SECTION ENDS------------------ */}
    </>
  )
}